import React, { useState, useEffect, useContext } from 'react';
import { Container, Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { LeadIndustry, LeadRating, LeadSource, LeadStatus } from '../../../utils/enums'
import UsersAutoComplete from '../../Users/UsersAutoComplete';
import { AuthContext } from '../../../context/AuthContext';
import { useSearchParams } from 'react-router-dom';

const CreateForm = ({ onSubmit }) => {
    const [searchParams] = useSearchParams();

    const nameParam = searchParams.get('leadName') || '';
    const parts = nameParam.trim().split(/\s+/);

    const [firstName, setFirstName] = useState(parts[0] || '');
    const [lastName, setLastName] = useState(parts.slice(1).join(' ') || '');

    const companyParam = searchParams.get('company') || '';
    const websiteParam = searchParams.get('website') || null;

    const [company, setCompany] = useState(companyParam);
    const [website, setWebsite] = useState(websiteParam);

    const { userId } = useContext(AuthContext);
    const [ownerId, setOwnerId] = useState(userId || '');
    const [email, setEmail] = useState(null);
    const [title, setTitle] = useState(null);
    const [fax, setFax] = useState(null);
    const [phone, setPhone] = useState(null);
    const [otherPhone, setOtherPhone] = useState(null);
    const [mobile, setMobile] = useState(null);
    const [leadStatus, setLeadStatus] = useState(0);
    const [leadSource, setLeadSource] = useState(0);
    const [numberOfEmployees, setNumberOfEmployees] = useState(0);
    const [leadIndustry, setLeadIndustry] = useState(0);
    const [skypeID, setSkypeID] = useState(null);
    const [annualRevenue, setAnnualRevenue] = useState(0);
    const [leadRating, setLeadRating] = useState(0);
    const [emailOptOut, setEmailOptOut] = useState(true);
    const [secondaryEmail, setSecondaryEmail] = useState(null);
    const [twitter, setTwitter] = useState(null);
    const [street, setStreet] = useState(null);
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [zipCode, setZipCode] = useState(null);
    const [country, setCountry] = useState(null);
    const [description, setDescription] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Collect all form data
        const formData = {
            ownerId,
            company,
            firstName,
            lastName,
            email,
            title,
            fax,
            phone,
            otherPhone,
            website,
            mobile,
            leadStatus,
            leadSource,
            numberOfEmployees,
            leadIndustry,
            skypeID,
            annualRevenue,
            leadRating,
            emailOptOut,
            secondaryEmail,
            twitter,
            street,
            city,
            state,
            zipCode,
            country,
            description,
            IsContact: false
            // Collect other fields as needed
        };
        // Call onSubmit function passed as a prop

        onSubmit(formData);
    };

    useEffect(() => {
        if (userId) {
            setOwnerId(userId);
        }
    }, [userId]);

    return (
        <form id='create-form' onSubmit={handleSubmit}>
            <Container maxWidth="md" sx={{ marginTop: "10px" }}>
                <h4>Lead Information</h4>
                <Grid container spacing={3}>
                    {/* Lead Owner */}
                    <Grid item xs={12} sm={6}>
                        <UsersAutoComplete userId={userId} setUserId={setOwnerId} />
                    </Grid>

                    {/* Company */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Company" required
                            value={company || ''}
                            onChange={(e) => setCompany(e.target.value)} />
                    </Grid>

                    {/* First Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="First Name" required
                            value={firstName || ''}
                            onChange={(e) => setFirstName(e.target.value)} />
                    </Grid>

                    {/* Last Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Last Name" required
                            value={lastName || ''}
                            onChange={(e) => setLastName(e.target.value)} />
                    </Grid>

                    {/* Email */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Email"
                            onChange={(e) => setEmail(e.target.value)} />
                    </Grid>

                    {/* Title */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Title"
                            onChange={(e) => setTitle(e.target.value)} />
                    </Grid>

                    {/* Fax */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Fax"
                            onChange={(e) => setFax(e.target.value)} />
                    </Grid>

                    {/* Website */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Website"
                            value={website || ''}
                            onChange={(e) => setWebsite(e.target.value)} />
                    </Grid>

                    {/* Phone */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Phone"
                            onChange={(e) => setPhone(e.target.value)} />
                    </Grid>

                    {/* Other Phone */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Other Phone"
                            onChange={(e) => setOtherPhone(e.target.value)} />
                    </Grid>

                    {/* Mobile */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Mobile"
                            onChange={(e) => setMobile(e.target.value)} />
                    </Grid>

                    {/* Lead Status */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={LeadStatus}
                            sx={{ width: "100%" }}
                            value={LeadStatus.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setLeadStatus(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Lead Status" />}
                        />
                    </Grid>

                    {/* Lead Source */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={LeadSource}
                            sx={{ width: "100%" }}
                            value={LeadSource.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setLeadSource(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Lead Source" />}
                        />
                    </Grid>

                    {/* No. of Employees */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="No. of Employees"
                            onChange={(e) => setNumberOfEmployees(e.target.value)} />
                    </Grid>

                    {/* Industry */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={LeadIndustry}
                            sx={{ width: "100%" }}
                            value={LeadIndustry.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setLeadIndustry(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Industry" />}
                        />
                    </Grid>

                    {/* Skype ID */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Skype ID"
                            onChange={(e) => setSkypeID(e.target.value)} />
                    </Grid>

                    {/* Annual Revenue */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            shrink
                            fullWidth
                            label="Annual Revenue"
                            InputProps={{ startAdornment: <span>$</span> }}
                            inputProps={{ inputMode: "decimal", pattern: "[0-9]*" }} // Restrict to numbers
                            onChange={(e) => {
                                const value = e.target.value;
                                const parsedValue = value ? parseFloat(value) : null;
                                if (isNaN(parsedValue)) {
                                    alert("Invalid annual revenue: must be a number.");
                                } else {
                                    setAnnualRevenue(parsedValue);
                                }
                            }}
                        />
                    </Grid>


                    {/* Rating */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={LeadRating}
                            sx={{ width: "100%" }}
                            value={LeadRating.find((option) => option.value === 0)}
                            onChange={(event, newValue) => setLeadRating(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Rating" />}
                        />
                    </Grid>

                    {/* Email Opt Out */}
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel control={<Checkbox />} label="Email Opt Out"
                            onChange={(e) => setEmailOptOut(e.target.checked)} />
                    </Grid>

                    {/* Secondary Email */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Secondary Email"
                            onChange={(e) => setSecondaryEmail(e.target.value)} />
                    </Grid>

                    {/* Twitter */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Twitter" InputProps={{ startAdornment: <span>@</span> }}
                            onChange={(e) => setTwitter(e.target.value)} />
                    </Grid>
                </Grid >
                <br />
                <h4>Address Information</h4>
                <Grid container spacing={3}>
                    {/* Street */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Street"
                            onChange={(e) => setStreet(e.target.value)} />
                    </Grid>

                    {/* City */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="City"
                            onChange={(e) => setCity(e.target.value)} />
                    </Grid>

                    {/* State */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="State"
                            onChange={(e) => setState(e.target.value)} />
                    </Grid>

                    {/* Zip Code */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Zip Code"
                            onChange={(e) => setZipCode(e.target.value)} />
                    </Grid>

                    {/* Country */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Country"
                            onChange={(e) => setCountry(e.target.value)} />
                    </Grid>
                </Grid >
                <br />
                <h4>Description Information</h4>
                <Grid container spacing={3}>
                    {/* Description */}
                    <Grid item xs={12} sm={12}>
                        <TextField multiline fullWidth label="Description"
                            onChange={(e) => setDescription(e.target.value)} />
                    </Grid>
                </Grid >
            </Container >
        </form>
    );
};

export default CreateForm;
